"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _flat = _interopRequireDefault(require("flat"));
var _utils = require("./utils");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/* eslint-disable func-names */

/**
 * @NOTE
 * Class inheritance was not working in production envs
 * Prototypes seem to register more consistently.
 */
URLSearchParams.prototype.populate = function () {
  let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.entries(a).reduce((acc, _ref) => {
    let [key, value] = _ref;
    return Object.assign(acc, {
      [key]: Array.isArray(value) ? this.getAll(`${key}[]`) : this.get(key) || value
    });
  }, {});
};
URLSearchParams.prototype.serializeAndAssign = function (key, v) {
  const arr = (0, _utils.serializeArray)(v);
  if (arr.length) {
    this.set((0, _utils.asInverted)(key, arr), (0, _utils.asEmpty)(arr));
  } else {
    this.delete(key);
  }
};
URLSearchParams.prototype.merge = function (a) {
  Object.entries(a).forEach(_ref2 => {
    let [key, v] = _ref2;
    if ((0, _utils.isEmpty)(v)) {
      this.delete(key);
    } else if (Array.isArray(v)) {
      this.serializeAndAssign(key, v);
    } else if (typeof v === 'object') {
      Object.entries((0, _flat.default)(v, {
        safe: true
      })).forEach(_ref3 => {
        let [name, value] = _ref3;
        this.serializeAndAssign(`${key}.${name}`, value);
      });
    } else {
      this.set((0, _utils.asInverted)(key, v), (0, _utils.asEmpty)(v));
    }
  });
};
URLSearchParams.prototype.redirectStr = function () {
  const output = (0, _utils.forEachParam)(this);
  const str = Object.entries(output).map(_ref4 => {
    let [key, value] = _ref4;
    const left = encodeURIComponent(key);
    return value ? `${left}=${encodeURIComponent(value)}` : left;
  }).join('&');
  return str ? `?${str}` : '?';
};
var _default = URLSearchParams;
exports.default = _default;